<template>
  <div class="accessibility-indicator">
    <span
      class="indicator-green"
      v-bind:style="{ width: String(calculateWidht())+'px', 'background-color':this.color}"
    ></span>
    <span class="indicator-grey" v-bind:style="{ width: String(80-calculateWidht())+'px'}"></span>
  </div>
</template>
<script>
export default {
  props: ["product_stock"],
  data() {
    return {
      color: "green",
      multiplier: 80
    };
  },
  methods: {
    calculateWidht() {
      if (this.product_stock < 10) {
        this.color = "red";
        return 0.3 * this.multiplier;
      } else if (this.product_stock >= 10 && this.product_stock < 30) {
        this.color = "#FFD300";
        return 0.6 * this.multiplier;
      } else {
        this.color = "rgb(55, 194, 55)";
        return 1 * this.multiplier;
      }
    }
  }
};
</script>
<style lang="scss">
.accessibility-indicator {
  display: inherit;
  width: 80px;
  margin-right: 10px;
  height: 40px;
  border: 1px solid #444;
}

.avalibilty-text {
  font-size: 12px;
  color: #000000;
}

.indicator-green {
  background-color: rgb(55, 194, 55);
}

.indicator-grey {
  background-color: rgb(228, 226, 226);
}
</style>



// WEBPACK FOOTER //
// src/components/products/src/productPage/AccessibilityIndicator.vue